// src/pages/Notifications.jsx
import { useState } from 'react';
import axios from 'axios';
import { FaPaperPlane } from 'react-icons/fa';
import { API_BASE } from '../utils/helpers';

export default function Notifications() {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const sendNotification = async (e) => {
    e.preventDefault();
    setLoading(true); setSuccess(''); setError('');
    try {
      const { data } = await axios.post(`${API_BASE}/api/admin/send-notification`, { title, message });
      setSuccess(`Sent to ${data.sent} users, ${data.failed} failed.`);
      setTitle(''); setMessage('');
    } catch (err) {
      setError(err.response?.data?.error || 'Error sending notification');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-slate-900">Notifications</h2>
        <p className="text-sm text-slate-500">Send a push notification to all app users.</p>
      </div>

      <div className="max-w-2xl">
        {success && <div className="mb-4 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-2.5 text-sm text-emerald-700">{success}</div>}
        {error && <div className="mb-4 rounded-lg border border-rose-200 bg-rose-50 px-4 py-2.5 text-sm text-rose-700">{error}</div>}

        <form onSubmit={sendNotification} className="ui-card p-6">
          <div className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700">Title</label>
              <input
                className="ui-input"
                type="text"
                placeholder="Enter notification title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700">Message</label>
              <textarea
                className="ui-input"
                rows={4}
                placeholder="Enter message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="mt-5">
            <button type="submit" className="ui-btn-primary" disabled={loading}>
              <FaPaperPlane className="text-xs" /> {loading ? 'Sending…' : 'Send notification'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
